module.exports = __webpack_public_path__ + "media/welcome-message/meetup@2x-0fd41fb3.png";